let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("36SvZ")).then(() => parcelRequire('nZnB0'));